import {Buffer} from 'buffer';

const convertToString = (data) => {
  if (!data) return '';

  // Try to detect if data is base64 encoded
  try {
    // Check if it's a valid base64 string
    if (
      typeof data === 'string' &&
      /^[A-Za-z0-9+/]*={0,2}$/.test(data) &&
      data.length % 4 === 0
    ) {
      const decoded = Buffer.from(data, 'base64').toString();
      // Simple check to see if decoded result makes sense
      if (decoded.length > 0 && !decoded.includes('\0')) {
        return decoded;
      }
    }
  } catch (e) {
    // If base64 decoding fails, return original
  }

  // Return data as-is if it's not base64 or decoding fails
  return data;
};

const OutputWindow = ({outputDetails}) => {
  const getOutput = () => {
    let statusId = outputDetails?.status?.id;
    console.log('statusId', statusId);
    console.log('outputDetails', outputDetails);

    if (statusId === 6) {
      // compilation error
      return (
        <pre className="px-2 py-1 text-xs font-normal text-red-500">
          {convertToString(outputDetails?.compile_output)}
        </pre>
      );
    } else if (statusId === 3) {
      const output = convertToString(outputDetails.stdout);
      return (
        <pre className="px-2 py-1 text-xs font-normal text-green-500">
          {output || 'No output'}
        </pre>
      );
    } else if (statusId === 5) {
      return (
        <pre className="px-2 py-1 text-xs font-normal text-red-500">
          {'Time Limit Exceeded'}
        </pre>
      );
    } else {
      return (
        <pre className="px-2 py-1 text-xs font-normal text-red-500">
          {convertToString(outputDetails?.stderr) || 'Runtime Error'}
        </pre>
      );
    }
  };

  return (
    <div className="flex h-full w-full flex-col">
      <h1 className="mb-2 bg-gradient-to-r from-slate-900 to-slate-700 bg-clip-text text-xl font-bold text-transparent">
        Output
      </h1>
      <div className="mb-2 h-full w-full overflow-y-auto rounded-md bg-[#1e293b] text-sm font-normal">
        {outputDetails ? <>{getOutput()}</> : null}
      </div>
    </div>
  );
};

export default OutputWindow;
